import { isObject } from '../is-object';
export function isJSSlot(data) {
  if (!isObject(data)) {
    return false;
  }
  return data.type === 'JSSlot';
}